"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.267 2.9H5.43A3.43 3.43 0 0 0 2 6.33v7.086a3.43 3.43 0 0 0 3.429 3.428h9.142A3.43 3.43 0 0 0 18 13.415V7.553a3.43 3.43 0 0 0-3.429-3.429h-4.75a2.28 2.28 0 0 1-1.295-.403l-.315-.216A3.43 3.43 0 0 0 6.267 2.9m4.135 4.403a.63.63 0 0 0-.804 0l-.843.701a.63.63 0 0 0 0 .967l.843.7c.233.194.57.194.804 0l.843-.7a.63.63 0 0 0 0-.967zM7.73 9.435a.63.63 0 0 0-.804 0l-.843.702a.63.63 0 0 0 0 .966l.843.701c.233.194.57.194.804 0l.843-.7a.63.63 0 0 0 0-.967zm5.342 0a.63.63 0 0 0-.804 0l-.843.702a.63.63 0 0 0 0 .966l.843.701a.628.628 0 0 0 .804 0l.843-.7a.63.63 0 0 0 0-.967zm-2.671 2.133a.63.63 0 0 0-.804 0l-.843.701a.63.63 0 0 0 0 .967l.843.7c.233.194.57.194.804 0l.843-.7a.63.63 0 0 0 0-.967z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  fillRule: "evenodd",
  d: "M9.604 7.308a.63.63 0 0 1 .804 0l.843.702a.63.63 0 0 1 0 .966l-.843.701a.63.63 0 0 1-.804 0l-.843-.701a.63.63 0 0 1 0-.966zM6.933 9.441a.63.63 0 0 1 .803 0l.843.701a.63.63 0 0 1 0 .966l-.843.702a.63.63 0 0 1-.803 0l-.844-.702a.63.63 0 0 1 0-.966zm5.342 0a.63.63 0 0 1 .804 0l.843.701a.63.63 0 0 1 0 .966l-.843.702a.63.63 0 0 1-.804 0l-.843-.702a.63.63 0 0 1 0-.966zm-2.671 2.132a.63.63 0 0 1 .804 0l.843.701a.63.63 0 0 1 0 .967l-.843.701a.63.63 0 0 1-.804 0l-.843-.701a.63.63 0 0 1 0-.966z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppFolderFillNavIcon20.js.map